/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

export default getValue;



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/_getValue.js
// module id = 1246
// module chunks = 14